import enLangFile from "@/lang/translations/en.json"

const getVoices = (selectedLanguage, getFilteredVoices, t) => {
    const { _invalidVoiceNames: invalidVoiceNames } = enLangFile
    let voices = getFilteredVoices.filter(voice => !invalidVoiceNames[voice.voiceCode] && !t(selectedLanguage + '.' + voice.voiceCode).includes(selectedLanguage)).map((voice, i) => {
        return {
            value: i,
            label: t(selectedLanguage + '.' + voice.voiceCode),
            gender: voice.label,
            voiceCode: voice.voiceCode,
            selected: voice.selected
        }
    })

    const tempDisableVoices = ['en-GB', 'fr-FR']
    tempDisableVoices.map((lang) => {
        if (lang === selectedLanguage) {
            voices = voices.filter(voice => !voice.voiceCode.includes('Wavenet') && !voice.voiceCode.includes('Standard'))
        } else if (selectedLanguage === 'nl-NL') {
            voices = voices.filter(voice => !voice.voiceCode.includes('Wavenet'))
        }
    })
    voices = [...voices.filter((v) => v.voiceCode.includes("Chirp3-HD")), ...voices.filter(voice => !voice.voiceCode.includes('Chirp3-HD'))]

    return voices
}
export { getVoices }